"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { Check, ChevronRight, ShieldCheck, Calendar, Info } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const models = [{
  id: "m1",
  name: "LITE",
  brand: "ThinkLocalPro"
}, {
  id: "m2",
  name: "GROWTH",
  brand: "ThinkLocalPro"
}, {
  id: "m3",
  name: "AUTHORITY",
  brand: "ThinkLocalPro"
}, {
  id: "m4",
  name: "ENTERPRISE",
  brand: "ThinkLocalPro"
}];
const checkoutUrls: Record<string, string> = {
  m1: "https://thinklocalpro.com/lite-checkout",
  m2: "https://thinklocalpro.com/growth-checkout",
  m3: "https://thinklocalpro.com/authority-checkout",
  m4: "https://thinklocalpro.com/enterprise-checkout"
};
const comparisonData = [{
  id: "f1",
  feature: "Monthly Investment",
  m1: "£69/mo",
  m1Highlight: false,
  m2: "£149/mo",
  m2Highlight: true,
  m3: "£499/mo",
  m3Highlight: false,
  m4: "Custom Quote",
  m4Highlight: false
}, {
  id: "f2",
  feature: "Missed Call Text-Back",
  m1: "Included",
  m1Highlight: true,
  m2: "Included",
  m2Highlight: false,
  m3: "Included",
  m3Highlight: false,
  m4: "Included",
  m4Highlight: false
}, {
  id: "f3",
  feature: "WhatsApp Automation",
  m1: "Standard Bot",
  m1Highlight: false,
  m2: "Pro AI Agent",
  m2Highlight: false,
  m3: "Advanced AI",
  m3Highlight: true,
  m4: "Dedicated AI",
  m4Highlight: false
}, {
  id: "f4",
  feature: "Google Review Bot",
  m1: "Manual Requests",
  m1Highlight: false,
  m2: "Automated",
  m2Highlight: true,
  m3: "Full Managed",
  m3Highlight: false,
  m4: "Full Managed",
  m4Highlight: false
}, {
  id: "f5",
  feature: "UK Business Number",
  m1: "Included",
  m1Highlight: true,
  m2: "Included",
  m2Highlight: false,
  m3: "Included",
  m3Highlight: false,
  m4: "Included",
  m4Highlight: false
}, {
  id: "f6",
  feature: "Unified Inbox",
  m1: "Basic (Text/Email/GMB)",
  m1Highlight: false,
  m2: "Plus (FB Sync)",
  m2Highlight: false,
  m3: "Premium (Advanced)",
  m3Highlight: true,
  m4: "Full Enterprise",
  m4Highlight: false
}, {
  id: "f7",
  feature: "AI Lead Recovery",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Included",
  m2Highlight: true,
  m3: "Priority AI",
  m3Highlight: false,
  m4: "Custom Logic",
  m4Highlight: false
}, {
  id: "f8",
  feature: "Support Level",
  m1: "Email Support",
  m1Highlight: false,
  m2: "Priority Chat",
  m2Highlight: false,
  m3: "24/7 Phone",
  m3Highlight: false,
  m4: "Account Manager",
  m4Highlight: true
}, {
  id: "f9",
  feature: "Social Media Planner",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Included",
  m2Highlight: true,
  m3: "Included",
  m3Highlight: true,
  m4: "Not Included",
  m4Highlight: false
}, {
  id: "f10",
  feature: "Web Chat Widget",
  m1: "Included",
  m1Highlight: false,
  m2: "Included",
  m2Highlight: false,
  m3: "Included",
  m3Highlight: false,
  m4: "Included",
  m4Highlight: false
}, {
  id: "f11",
  feature: "Reputation Mgmt",
  m1: "Included",
  m1Highlight: false,
  m2: "Included",
  m2Highlight: false,
  m3: "Included",
  m3Highlight: false,
  m4: "Included",
  m4Highlight: false
}, {
  id: "f12",
  feature: "Smart Calendar/CRM",
  m1: "Basic",
  m1Highlight: false,
  m2: "Unlimited",
  m2Highlight: false,
  m3: "Advanced",
  m3Highlight: false,
  m4: "Custom",
  m4Highlight: false
}, {
  id: "f13",
  feature: "Funnels & Websites",
  m1: "1 Funnel",
  m1Highlight: false,
  m2: "Unlimited",
  m2Highlight: false,
  m3: "Unlimited",
  m3Highlight: false,
  m4: "Unlimited",
  m4Highlight: false
}, {
  id: "f14",
  feature: "Email Marketing",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Full Builder",
  m2Highlight: false,
  m3: "Full Builder",
  m3Highlight: false,
  m4: "Custom Logic",
  m4Highlight: false
}, {
  id: "f15",
  feature: "Invoicing & Payments",
  m1: "Text To Pay",
  m1Highlight: false,
  m2: "Professional",
  m2Highlight: false,
  m3: "Full System",
  m3Highlight: false,
  m4: "Enterprise",
  m4Highlight: false
}, {
  id: "f16",
  feature: "Forms & Surveys",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Custom",
  m2Highlight: false,
  m3: "Custom",
  m3Highlight: false,
  m4: "Custom",
  m4Highlight: false
}, {
  id: "f17",
  feature: "Workflows",
  m1: "Basic",
  m1Highlight: false,
  m2: "Robust",
  m2Highlight: false,
  m3: "System Triggers",
  m3Highlight: false,
  m4: "Full Custom",
  m4Highlight: false
}, {
  id: "f18",
  feature: "Membership Sites",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Private Communities",
  m2Highlight: false,
  m3: "Unlimited",
  m3Highlight: false,
  m4: "Unlimited",
  m4Highlight: false
}, {
  id: "f19",
  feature: "Blog Manager",
  m1: "Not Included",
  m1Highlight: false,
  m2: "Not Included",
  m2Highlight: false,
  m3: "SEO Managed",
  m3Highlight: false,
  m4: "Included",
  m4Highlight: false
}, {
  id: "f20",
  feature: "Analytics/Reporting",
  m1: "Standard",
  m1Highlight: false,
  m2: "Standard",
  m2Highlight: false,
  m3: "Advanced",
  m3Highlight: false,
  m4: "Custom",
  m4Highlight: false
}];
export default function SideBySideComparison() {
  const [selectedModels, setSelectedModels] = useState<string[]>([]);
  const toggleModel = (modelId: string) => {
    setSelectedModels(prev => prev.includes(modelId) ? prev.filter(id => id !== modelId) : [...prev, modelId]);
  };
  const getCheckoutUrl = () => {
    if (selectedModels.length === 0) return "";
    return checkoutUrls[selectedModels[0]] || "";
  };
  return <section data-section-id="117147" id="compare-plans" className="bg-background py-20 md:py-32 relative overflow-hidden radiating-pattern">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-primary/10 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-secondary/10 blur-[100px] rounded-full" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 gap-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-none border-l-4 border-primary bg-primary/5 text-primary text-xs font-bold uppercase tracking-widest mb-6">
              <ShieldCheck className="size-4" />
              <span>Professional Tier Audit</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-sans font-extrabold tracking-tighter text-foreground mb-6 uppercase">
              Side-by-Side <span className="text-primary">Comparison</span>
            </h2>
            <p className="text-lg md:text-xl font-sans font-medium text-muted-foreground max-w-2xl">
              Evaluate the "Silent Operator" capabilities across our professional tiers. Select a plan to lock in your Founding Member status before the May launch.
            </p>
          </div>
          
          <div className="flex-shrink-0 w-full lg:w-auto">
            <div className="bg-card/50 backdrop-blur-md border border-border rounded-none p-6 shadow-xl flex flex-col sm:flex-row items-center gap-6">
              <div className="flex flex-col items-center sm:items-start">
                <span className="text-xs text-muted-foreground font-bold uppercase tracking-widest mb-1">Selected Tiers</span>
                <span className="text-4xl font-extrabold text-foreground font-sans">{selectedModels.length}</span>
              </div>
              <div className="h-px w-full sm:h-12 sm:w-px bg-border" />
              {selectedModels.length > 0 ? <Button className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-none font-bold uppercase tracking-wider px-8 py-6 h-auto shadow-[4px_4px_0px_0px_rgba(0,0,0,0.1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.05)]" asChild>
                  <Link to={getCheckoutUrl()}>
                    Secure Founder Spot <ChevronRight className="ml-2 size-5" />
                  </Link>
                </Button> : <Button disabled className="w-full sm:w-auto bg-muted text-muted-foreground rounded-none font-bold uppercase tracking-wider px-8 py-6 h-auto opacity-50">
                  Select a Tier <ChevronRight className="ml-2 size-5" />
                </Button>}
            </div>
          </div>
        </div>

        <div className="bg-card/30 backdrop-blur-sm border border-border rounded-none shadow-2xl overflow-hidden">
          <Table className="w-full text-sm md:text-base font-sans border-collapse">
            <TableHeader>
              <TableRow className="bg-muted/20 hover:bg-muted/20 border-b border-border">
                <TableHead className="sticky left-0 z-20 bg-card/95 backdrop-blur-md border-r border-border min-w-[220px] shadow-[4px_0_12px_-4px_rgba(0,0,0,0.1)] dark:shadow-[4px_0_12px_-4px_rgba(0,0,0,0.5)] align-bottom pb-8 pt-8 px-6">
                  <span className="font-sans font-extrabold text-foreground text-xl uppercase tracking-tight">Core Features</span>
                </TableHead>
                {models.map((model, i) => <TableHead key={model.id} data-index={i} className="min-w-[240px] bg-transparent text-center p-8 align-top border-b border-border">
                    <div className="flex flex-col items-center gap-4">
                      <div className="flex items-center space-x-3 bg-background/50 border border-border rounded-none px-4 py-2.5 shadow-sm transition-all hover:border-primary/50 group cursor-pointer">
                        <Checkbox id={`quote-${model.id}`} checked={selectedModels.includes(model.id)} onCheckedChange={() => toggleModel(model.id)} className="data-[state=checked]:bg-primary data-[state=checked]:border-primary" />
                        <label htmlFor={`quote-${model.id}`} className="text-xs font-bold uppercase tracking-widest leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer select-none font-sans text-muted-foreground group-hover:text-foreground transition-colors">
                          Tier
                        </label>
                      </div>
                      <div className="mt-2">
                        <div className="text-[10px] font-black text-primary uppercase tracking-[0.2em] mb-2">
                          {model.brand}
                        </div>
                        <div className="font-sans font-black text-foreground text-2xl leading-tight uppercase tracking-tighter">
                          {model.name}
                        </div>
                      </div>
                    </div>
                  </TableHead>)}
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((row, i) => <TableRow key={row.id} data-index={i} className="group hover:bg-primary/5 transition-colors border-b border-border/50">
                  <TableCell className="sticky left-0 z-10 bg-card/95 backdrop-blur-md group-hover:bg-card border-r border-border font-bold text-foreground shadow-[4px_0_12px_-4px_rgba(0,0,0,0.1)] dark:shadow-[4px_0_12px_-4px_rgba(0,0,0,0.5)] transition-colors py-5 px-6 font-sans">
                    <div className="flex items-center gap-3">
                      {row.id === "f9" ? <SafeHydrate><Calendar className="size-4 text-primary shrink-0" /></SafeHydrate> : <div className="size-1.5 rounded-full bg-primary/40 shrink-0" />}
                      <span className="uppercase text-sm tracking-wide">{row.feature}</span>
                    </div>
                  </TableCell>
                  {models.map((model, j) => {
                const value = row[model.id as keyof typeof row] as string;
                const isHighlight = row[`${model.id}Highlight` as keyof typeof row] as boolean;
                return <TableCell key={`${row.id}-${model.id}`} data-index={j} className="text-center py-5 px-6">
                        <div className={`inline-flex items-center justify-center gap-2 px-5 py-2 rounded-none text-xs font-bold uppercase tracking-widest transition-all ${isHighlight ? "text-primary bg-primary/10 border border-primary/30 shadow-[inset_0_0_10px_rgba(255,140,0,0.05)]" : "text-muted-foreground/80 font-semibold"}`}>
                          {isHighlight && <Check className="size-3.5 stroke-[3px]" />}
                          {value}
                        </div>
                      </TableCell>;
              })}
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
        
        <div className="mt-10 flex flex-col md:flex-row justify-between items-center gap-6">
           <div className="flex items-center gap-3 text-xs text-muted-foreground font-sans font-bold uppercase tracking-widest">
             <div className="flex items-center justify-center size-6 rounded-none bg-primary/10 border border-primary/30">
               <div className="flex items-center justify-center">
                 <Info className="size-3.5 text-primary" />
               </div>
             </div>
             <span>All plans include UK-based technical support and 99.9% uptime guarantee.</span>
           </div>
           <p className="text-[10px] text-muted-foreground/60 flex items-center gap-2 font-sans uppercase tracking-[0.15em]">
             <span className="inline-block w-2 h-2 rounded-full bg-primary/40" />
             Indicates industry-leading automation features for UK trade growth.
           </p>
        </div>
      </div>
    </section>;
}